import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-368">
      <div className="max-w-5xl mx-auto" data-id="element-369">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-370">
          Lo que <span className="text-[#00B4D8]" data-id="element-371">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-372">
          <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6" data-id="element-373">
            <h3 className="text-[#00B4D8] text-xl font-black mb-2" data-id="element-374">
              🎾 LOS 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-375">
              Para profesores de tenis de todos los niveles
            </p>
            <div className="space-y-4" data-id="element-376">
              <div className="flex items-center gap-3 text-white" data-id="element-377">
                <span className="text-xl" data-id="element-378">🟢</span>
                <div className="flex-1" data-id="element-379">
                  <span className="font-bold" data-id="element-380">Tomo 1 — Iniciación Sub-10</span>
                  <span className="text-gray-300" data-id="element-381">
                    {' '}
                    48 semanas · Fundamentos y psicomotricidad
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-382">
                <span className="text-xl" data-id="element-383">🟡</span>
                <div className="flex-1" data-id="element-384">
                  <span className="font-bold" data-id="element-385">Tomo 2 — Junior Intermedio</span>
                  <span className="text-gray-300" data-id="element-386">
                    {' '}
                    48 semanas · Técnica, táctica y competencia
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-387">
                <span className="text-xl" data-id="element-388">🟠</span>
                <div className="flex-1" data-id="element-389">
                  <span className="font-bold" data-id="element-390">
                    Tomo 3 — Adultos Nivel Social
                  </span>
                  <span className="text-gray-300" data-id="element-391">
                    {' '}
                    48 semanas · Grupos, retención y fidelización
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-392">
                <span className="text-xl" data-id="element-393">🔴</span>
                <div className="flex-1" data-id="element-394">
                  <span className="font-bold" data-id="element-395">Tomo 4 — Nivel Avanzado</span>
                  <span className="text-gray-300" data-id="element-396">
                    {' '}
                    48 semanas · Periodización y alto rendimiento
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-397">
                <span className="text-xl" data-id="element-398">🟣</span>
                <div className="flex-1" data-id="element-399">
                  <span className="font-bold" data-id="element-400">
                    Tomo 5 — Táctica y Estrategia
                  </span>
                  <span className="text-gray-300" data-id="element-401">
                    {' '}
                    Patrones, superficies y lectura del rival
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-402">
                <span className="text-xl" data-id="element-403">⭐</span>
                <div className="flex-1" data-id="element-404">
                  <span className="font-bold" data-id="element-405">Tomo 6 — Físico y Mental</span>
                  <span className="text-gray-300" data-id="element-406">
                    {' '}
                    Físico en cancha, nutrición y psicología
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00B4D8]/5 border border-[#00B4D8]/30 rounded-2xl p-8 text-center" data-id="element-407">
          <h3 className="text-[#00B4D8] text-xl font-black mb-6" data-id="element-408">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-409">
            <div className="flex items-start gap-2 text-left" data-id="element-410">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-411">✅</span>
              <span className="text-white text-sm" data-id="element-412">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-413">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-414">✅</span>
              <span className="text-white text-sm" data-id="element-415">
                48 semanas con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-416">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-417">✅</span>
              <span className="text-white text-sm" data-id="element-418">
                Sistema "Abrir y Dictar" (leés en 3 min antes de entrar)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-419">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-420">✅</span>
              <span className="text-white text-sm" data-id="element-421">
                Fichas de progreso y evaluación por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-422">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-423">✅</span>
              <span className="text-white text-sm" data-id="element-424">
                Variantes para nivel más fácil y más difícil
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-425">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-426">✅</span>
              <span className="text-white text-sm" data-id="element-427">
                Ejercicios adaptados a 1, 2, 4, 8 y 12 alumnos
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-428">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-429">✅</span>
              <span className="text-white text-sm" data-id="element-430">
                Material original EDULABS™
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-431">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-432">✅</span>
              <span className="text-white text-sm" data-id="element-433">
                Adaptado a todos los niveles y categorías
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}